module.exports = __webpack_public_path__ + "img/language-small.32732400.png";